<template lang="pug">
.k-field-rating
  k-field-wrapper(
    v-bind="$props"
    :side-hint="sideHint"
    :hint="hint"
    :label="topLabel ? labelI18n : false"
  )
    k-card(color="brand-grey-10" :class="$vuetify.breakpoint.mdAndUp ? 'd-inline-block' : ''").fill-width
      k-card-text.ma-0.text-xs-center
        v-rating(
          v-bind="$data.$_attrs"
          v-on="$data.$_listeners"
          :label="topLabel ? '' : labelI18n"
          ref="field"
          :value="value"
        )
          template(v-slot:item="props")
            .k-field-rating__star.d-inline-flex
              .flex-column
                k-icon(
                  :size="40"
                  @click="props.click"
                  :color="props.isFilled ? 'brand-dark-aqua' : 'brand-warm-grey'"
                ).pa-0.my-3 {{ props.isFilled ? 'ratingFull' : 'ratingOutline'}}
                .paragraph.font-weight-bold.mt-2 {{ props.index + 1 }}
    v-messages(:value="errorMessages").error--text

</template>

<script>
import { IsField, BindsAttrs } from '@/mixins'

export default {
  mixins: [
    IsField,
    BindsAttrs,
  ]
}
</script>

<style lang="scss" scoped>
.k-field-rating {
  &__error {
    font-size: 13px;
  }

  .k-card {
    box-shadow: none !important;
  }

  // add margin to the right to all except the last child
  &__star {
    margin-right: 27px;

    @include xs-only {
      margin-right: 9px;

      .k-icon {
        height: 30px !important;
      }
    }
  }

  &__star:last-child {
    margin-right: 0;
  }
}
</style>
